import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderEventService {
  public $menuToggle = new BehaviorSubject<boolean>(false)

  toggleMenu(isMenuOpen: boolean) {
    this.$menuToggle.next(isMenuOpen)
  }
}
